// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3gOxM","title":"AfterFrontImage_title__3NIne"};